import { render } from "./TabTemplates.vue?vue&type=template&id=415f3737&scoped=true"
import script from "./TabTemplates.vue?vue&type=script&lang=js"
export * from "./TabTemplates.vue?vue&type=script&lang=js"

import "./TabTemplates.vue?vue&type=style&index=0&id=415f3737&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415f3737"]])

export default __exports__